const ASC = 'ASC';
const DESC = 'DESC';
const NONE = 'NONE';

export default Object.freeze({
    ASC,
    DESC,
    NONE
});